import isNil from 'lodash/isNil';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Space from '@/components/layout/Space';
import { MoneyType } from '@/model/common';
import { makeSelectLocale } from '@/model/global/selectors';

const selectLocale = makeSelectLocale();

export interface MoneyAmountValueProps {
  'data-test'?: string;
  value?: MoneyType;
  withSign?: boolean;
  withCurrency?: boolean;
  fraction?: number;
  className?: string;
  style?: React.CSSProperties;
  currencyClassName?: string;
}

const MoneyAmountValue: React.FC<MoneyAmountValueProps> = ({
  value,
  withSign,
  withCurrency,
  fraction,
  className,
  style,
  currencyClassName,
  'data-test': dataTest,
}) => {
  const locale = useSelector(selectLocale);
  return !isNil(value) ? (
    <Space className={className} style={{ display: 'inline-flex', ...style }} size={0.6}>
      <span style={{ display: 'inline-flex' }} className="ym-hide-content" data-test={dataTest && `${dataTest}-amount`}>
        {withSign && value > 0 ? '+' : ''}
        {((value || 0) / 100).toLocaleString(locale, { minimumFractionDigits: fraction })}
      </span>
      {withCurrency && (
        <span className={currencyClassName} data-test={dataTest && `${dataTest}-currency`}>
          <FormattedMessage id="common.components.money.currency" />
        </span>
      )}
    </Space>
  ) : (
    <></>
  );
};

export default MoneyAmountValue;
